import { Inject, Injectable, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';

@Injectable({
  providedIn: 'root'
})
export class StorageService {

  constructor() { }

  setToken(token: string) {
    localStorage.setItem('token', token);
  }

  getToken(): string {
    return localStorage.getItem('token') || sessionStorage.getItem('token') || '';
  }

  setUserData(data: any, isInLocalStorage: boolean = true) {
    if (isInLocalStorage) {
      localStorage.setItem('userData', JSON.stringify(data));
    } else {
      sessionStorage.setItem('userData', JSON.stringify(data));
    }
  }

  getUserData(): any {
    return JSON.parse(localStorage.getItem('userData') as any) || JSON.parse(sessionStorage.getItem('userData') as any);
  }

  setUserRole(data: any,) {
    localStorage.setItem('role', data);
  }

  getUserRole(): any {
    return localStorage.getItem('role') || sessionStorage.getItem('role') || '';
  }

  logout(): void {
    localStorage.removeItem('token');
    localStorage.removeItem('userData');
    localStorage.removeItem('role');
  }
}
